module.exports = __webpack_public_path__ + "public/images/woman-header-tutoring.dd1f1c0aa9ec1700a042f3928fa9b0b1.png";